<div class="flex flex-col h-full p-4 pt-0">
    <div class="flex flex-wrap justify-between items-center gap-4 mb-4">
        <div class="text-xl font-semibold">Calls by Month</div>
        <p-multiSelect
            [options]="availableYears()"
            [ngModel]="selectedYears()"
            (ngModelChange)="selectedYears.set($event)"
            defaultLabel="Select Years"
            [showClear]="false"
            styleClass="w-auto"
        ></p-multiSelect>
    </div>

    <!-- Loading Skeleton -->
    <div *ngIf="isLoading()" class="chart-container md:h-[480px] flex items-center justify-center">
        <div class="flex flex-col items-center gap-3">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <p class="text-gray-500 text-sm">Loading chart...</p>
        </div>
    </div>
    
           <!-- Chart Content -->
       <div *ngIf="!isLoading()" class="chart-container md:h-[480px]">
            <canvas
                baseChart
                [data]="chartData()"
                [options]="chartOptions"
                type="line"
            >
            </canvas>
        </div>
</div> 